import React from "react"
import Layout from "../components/layout"
import ReactDOM from 'react-dom';
import '../components/index.css';
import App from '../components/App';



export default () => (
  <Layout>
    <h1>Welcome!</h1>
    <p>
      I am currently a freshman studying computer science at Columbia University. I have been programming for over 4 years, and have experience in full stack development, computational biology, and data science.
    </p>
    <p>
      I see myself as an engineer in mind and entrepreneur at heart. Whenever I work on a project, I always look for larger social implications of my work.
    </p>
    <p>
    I am always looking for new opportunities to learn and apply my skills. Feel free to look around my website to learn more about my experience and see some examples of my projects. 
    </p>
  </Layout>
)
